import ApiCrud from "./api-crud";

class PersonalService extends ApiCrud {
  resource = "personales";
  primaryKey = "idpersonal";
}

export default new PersonalService();
